// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
	width: 100%;
	height: 100%;
	position: relative;
}
.infoBlock {
	position: relative;
  height: 80px;
}
.labeltext {
	font-size: 20px;
}
.mapContainer {
	border: solid black 2px;
	height: calc(100% - 100px);
	width: calc(100% - 80px);
	margin-left: 40px;
}

.noBlock {
	display: inline-block;
}`, "",{"version":3,"sources":["webpack://./src/demos/MinimalDemo/min.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;AACnB;AACA;CACC,kBAAkB;EACjB,YAAY;AACd;AACA;CACC,eAAe;AAChB;AACA;CACC,uBAAuB;CACvB,0BAA0B;CAC1B,wBAAwB;CACxB,iBAAiB;AAClB;;AAEA;CACC,qBAAqB;AACtB","sourcesContent":[".container {\n\twidth: 100%;\n\theight: 100%;\n\tposition: relative;\n}\n.infoBlock {\n\tposition: relative;\n  height: 80px;\n}\n.labeltext {\n\tfont-size: 20px;\n}\n.mapContainer {\n\tborder: solid black 2px;\n\theight: calc(100% - 100px);\n\twidth: calc(100% - 80px);\n\tmargin-left: 40px;\n}\n\n.noBlock {\n\tdisplay: inline-block;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
